import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import { textFieldValidate } from './fieldValidateUtil';
import PlaceholderFieldsModal from '../../../../common/ui/PlaceholderFieldsModal';
import { toast } from 'react-toastify';

const PLACEHOLDER_FIELDS_DATA = {
  defaultCategory: 'meta-fields',
  categories: [
    {
      name: 'meta-fields',
      title: 'Meta Fields',
      icon: 'meta-fields',
      fields: [
        {
          name: 'IP_ADDRESS',
          title: 'IP Address',
        },
        {
          name: 'CURRENT_DATE_TIME',
          title: 'Current Date Time',
        },
        {
          name: 'TIMESTAMP_IN_SEC',
          title: 'Timestamp in Seconds',
        },
        {
          name: 'TIMESTAMP_IN_MILLISEC',
          title: 'Timestamp in Milliseconds',
        },
        {
          name: 'USER_AGENT',
          title: 'User Agent',
        },
        {
          name: 'PLATFORM',
          title: 'Platform',
        },
      ],
    },
  ],
};
class TextField extends Component {
  state = {
    showModalForMetaFields: false,
  };

  validate = (value) => {
    return textFieldValidate(value, this.props.field, this.props.isConstructorForm);
  };

  toggleMetaFieldsModal = () => {
    this.setState({ showModalForMetaFields: !this.state.showModalForMetaFields });
  };

  copyToClipboard = () => {
    this.setState({
      copied: true,
      showModalForMetaFields: !this.state.showModalForMetaFields,
    });
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToParamInput = (textToInsert) => {
    if (textToInsert) {
      const inputElem = document.querySelector(
        `.collection-constructor-form [name=${this.props.field.fieldName}]`,
      );
      let start = inputElem.selectionStart;
      // obtain the index of the last selected character
      let finish = inputElem.selectionEnd;
      //obtain all Text
      let allText = inputElem.value;
      // obtain the selected text
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }
      this.props.values[this.props.field.fieldName] = newText;
      this.setState({
        showModalForMetaFields: !this.state.showModalForMetaFields,
      });
      toast.success('Inserted into Input Field');
    }
  };

  showCollectionMetaFieldModal = () => {
    const { collections } = this.props;
    return (
      <PlaceholderFieldsModal
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToParamInput}
        toggleFields={this.state.showModalForMetaFields}
        toggleFieldsModal={this.toggleMetaFieldsModal}
        fieldsData={PLACEHOLDER_FIELDS_DATA}
        collections={collections}
      />
    );
  };

  render() {
    const { field, isConstructorForm } = this.props;
    return (
      <>
        {this.state.showModalForMetaFields &&
          isConstructorForm &&
          this.showCollectionMetaFieldModal()}
        <Field
          type={field.type}
          name={field.fieldName}
          className="form-control form-control-sm"
          validate={this.validate}
          placeholder={field.placeholder['en']}
          autoComplete="off"
          title={field.fieldTitle['en']}
        />
        {isConstructorForm && (
          <div className="input-group-append">
            <span className="input-group-text">
              <button
                type="button"
                className="btn btn-theme-submit btn-xs btn-icon-only"
                title="Add Meta Fields"
                onClick={() => {
                  this.toggleMetaFieldsModal();
                }}
              >
                <i className="wb webconnect-plus" />
              </button>
            </span>
          </div>
        )}
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default TextField;
